var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4583 6.04167L12.342 7.15792L14.3845 9.20833H6.33325V10.7917H14.3845L12.342 12.8342L13.4583 13.9583L17.4166 10M3.16659 4.45833H9.49992V2.875H3.16659C2.29575 2.875 1.58325 3.5875 1.58325 4.45833V15.5417C1.58325 16.4125 2.29575 17.125 3.16659 17.125H9.49992V15.5417H3.16659V4.45833Z",
    fill: "#EF4444"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.435a0cce3fb5178107e39f16d32e7dae.svg";
export { ForwardRef as ReactComponent };